module.exports = __webpack_public_path__ + "img/farming_17.52a0e17c.png";